<div mat-dialog-title>
  <div class="row row--space-between row--valign-center">
    <label class="semi-bold">{{ 'App.ViewPdf.Labels.Title' | translate }}</label>
    <button mat-button (click)="closePdfViewer()" class="float-right">
      <span class="icon-x"></span>
    </button>
  </div>
</div>
<div mat-dialog-content *ngIf="pdfUrl">
  <iframe class="pdf-viewer-iframe" [src]="pdfUrl"></iframe>
</div>

<div class="row row--space-between" mat-dialog-actions>
  <button mat-button class="secondary-button rounded" (click)="closePdfViewer()">
    <span class="icon-x mr--xs"></span>
    <span>{{ 'App.ViewPdf.Buttons.Close' | translate }}</span>
  </button>
</div>
